<template>
  <div>
    <button
      class="custom-button"

      @click="handleAddMissingSerial"
    >
      {{ buttonLabel }}
    </button>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { router } from '@/router'
import { Route } from '@/router/routes'
import { useContext } from '@/plugins/context'

export default defineComponent({
  name: 'add-missing-serials',
  setup() {
    const c = useContext()
    const buttonLabel = c.locale === 'ar' ? 'اضافة الارقام التسلسلة المفقودة' : 'Add Missing Serials'
    return { buttonLabel }
  },

  methods: {
    handleAddMissingSerial() {
      router?.push(Route.INVENTORY_ADD_MISSING_SERIALS.replace(':id', this.params?.data.id)+`?location_id=${this.params.data.location_id}`)
    }
  }
})
</script>

<style>
.custom-button {
  @apply flex items-center justify-center w-full;
  color: blue;
}
</style>
